import { APP_KEY_IDS, DEVICE_TYPE, colorOptions } from "../../../../constants/constants";
import Styles from "./NotificationPanel.module.scss";
import classnames from "classnames"

import { ReactComponent as WifiIcon } from "../../../../icons/common/wifi.svg"
import { ReactComponent as SettingsIcon } from "../../../../icons/extra_icons/ac_settings.svg"
import { ReactComponent as BluetoothIcon } from "../../../../icons/common/bluetooth.svg"
import { ReactComponent as SoundIcon } from "../../../../icons/common/sound.svg"
import { ReactComponent as RotationIcon } from "../../../../icons/extra_icons/rotation_lock.svg"
import { ReactComponent as TorchIcon } from "../../../../icons/extra_icons/torch.svg"
import { ReactComponent as FlightModeIcon } from "../../../../icons/extra_icons/flight_mode.svg"
import { ReactComponent as MobileDataIcon } from "../../../../icons/extra_icons/mobile_data.svg"
import { ReactComponent as ThemeIcon } from "../../../../icons/extra_icons/samsung_theme_mode.svg"
import { ReactComponent as BrightnessIcon } from "../../../../icons/common/brightness.svg"

import { useEffect, useState } from "react";
import NotificationCard from "../../../notification-card/NotificationCard";
import ActionCenter from "../ActionCenter";
import { useSwipeable } from "react-swipeable";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import handleNotifications from "../../../../reducers/handleNotifications";
import { clearAllNotifications } from "../../../../actions/notifications";
import { openWindow } from "../../../../actions";
interface NotificationPanelProps {
    customClass?:string;
}

const NotificationPanel = ({customClass}:NotificationPanelProps) => {

    const dispatch = useDispatch()

    
    
    const notifications = useSelector((state:RootStateOrAny)=>state.handleNotifications)

    const [currentTime, setTime] = useState(new Date())
    const [dismissingNotification, setDismissingNotification] = useState(false)
    const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

    useEffect(() => {
        setInterval(() => {
            setTime(new Date())
        }, 1000)
    }, [])


    const [isDarkMode, setIsDarkMode] = useState(document.body.classList.contains("dark"))
    const [brightness, setBrightness] = useState(Number(document.documentElement.style.getPropertyValue(('--brightness'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--brightness'))) * 100 : 100)

    const handleThemeClick = () => {
        document.body.classList.toggle("dark");
        setIsDarkMode(!isDarkMode)
    }


    const notificationPanelOptions = [
        {
            id: "wifi",
            label: "Wifi",
            component: <WifiIcon />,
            isEnabled: true,
            color: colorOptions[0].color
        },
        {
            id: "sound",
            label: "Sound",
            component: <SoundIcon />,
            isEnabled: true,
            color: colorOptions[2].color
        },
        {
            id: "bluetooth",
            label: "Bluetooth",
            component: <BluetoothIcon />,
            isEnabled: true,
            color: colorOptions[1].color
        }, ,
        {
            id: "theme",
            label: `${isDarkMode?"Light":"Dark"} Mode`,
            component: <ThemeIcon />,
            isEnabled: isDarkMode,
            color: colorOptions[6].color,
            onClick: () => { handleThemeClick() }
        },
        {
            id: "rotation",
            label: "Rotation",
            component: <RotationIcon />,
            color: colorOptions[3].color
        },
        {
            id: "torch",
            label: "Torch",
            component: <TorchIcon />,
            color: colorOptions[4].color
        },
        {
            id: "flight_mode",
            label: "FlightMode",
            component: <FlightModeIcon />,
            color: colorOptions[5].color
        },
        {
            id: "mobile_data",
            label: "Mobile Data",
            component: <MobileDataIcon />,
            color: colorOptions[6].color
        }
    ]


    const handleBirghtness = (event: any) => {
        setBrightness(event.target.value)
        document.documentElement.style.setProperty(('--brightness'), String(event.target.value / 100))
    }

    const dismissBotifications =() => { 
        setDismissingNotification(true)
        setTimeout(()=>{
            dispatch(clearAllNotifications())
        },1000/notifications.length)
    }

    return (
        <div className={classnames(Styles.container,customClass && customClass)}>
            <ActionCenter isDragable={false}/>
            <div className={Styles.notfication_panel}>

                <div className={Styles.flex}>
                    <div className={Styles.date}>
                        {`${currentTime.getDate()} ${month[currentTime.getMonth()]}`}
                    </div>
                    <div className={Styles.icon} onClick={()=>{dispatch(openWindow(APP_KEY_IDS.MOBILE_SETTINGS))}}>
                        <SettingsIcon />
                    </div>
                </div>
                <div className={Styles.options} >
                    {
                        notificationPanelOptions.map((option: any) => {
                            return (
                                <div className={classnames(Styles.option)} onClick={option.onClick} key={option.id} >
                                    <div className={classnames(Styles.icon, option.isEnabled ? Styles.enabled : Styles.not_enabled)}>
                                        {option.component}
                                    </div>
                                    <div className={Styles.label}>
                                        {option.label}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={Styles.brightness} >
                    <input onChange={handleBirghtness} type="range" min={0} max={100} value={brightness} className={Styles.slider} name="bri" id="bri" />

                    <div className={Styles.slider_icon}>
                        <BrightnessIcon />
                    </div>

                </div>

                <div className={Styles.music}>
                    <iframe className={Styles.music_frame} src="https://open.spotify.com/embed/playlist/5u1XZZd8NNKauJc581CWSZ?utm_source=generator" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
                </div>

                {
                    Object.keys(notifications).length
                        ?
                        <>
                            <ul className={Styles.notifications}>
                                {
                                    Object.keys(notifications).map((key: any, index: number) => {
                                        return (
                                            <li key={index} style={{animationDelay:`${index/4}s`}} className={classnames(index < notifications.length - 1 ? Styles.notification_block : "", dismissingNotification && Styles.animate_dismissal)} >
                                                <NotificationCard id={key} deviceType={DEVICE_TYPE.MOBILE} mobileAppId={notifications[key].mobileAppId} appId={notifications[key].appId} appName={notifications[key].appName} title={notifications[key].title} subText={notifications[key].subText} time={notifications[key].time}  bannerImage={notifications[key].bannerImage || ""} visitLink={notifications[key].visitLink || ""}/>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                            <div className={Styles.flex} style={{ justifyContent: "flex-end" }}>
                                <div className={Styles.clear_button} onClick={dismissBotifications} >Clear</div>
                            </div>
                        </>
                        : null
                }
            </div>
        </div>
    )
}

export default NotificationPanel
